// @flow
/**
 * Show a blank page with message in the center
 * Usage scenario: secondary user may have no privilege to view a page
 */
import React from 'react'
import { Div } from 'glamorous'
import ErrorCommon from '../../transfer/components/errorCommon'

type Props = {
  message: string,
}
export default function BlankPagePlaceholder({ message = '' }: Props) {
  return (
    <Div padding="80px 20px">
      <ErrorCommon
        hideServiceMessage={true}
        message={message}
        status="WARNING"
      />
    </Div>
  )
}
